// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.katex-display {
  margin: 0.25em 0 !important;
}

/*.dg input, .dg select {*/
/*  color: black;*/
/*  line-height: normal !important;*/
/*}*/

/*.dg li {*/
/*  list-style: none !important;*/
/*}*/

/*.dg li > * {*/
/*  margin-bottom: 0 !important;*/
/*}*/

/*.dg input, .dg select {*/
/*  padding: 3px !important;*/
/*  display: block !important;*/
/*  box-shadow: none !important;*/
/*  font-size: 100% !important;*/
/*  border: 0 !important;*/
/*}*/

/*.dg.a {*/
/*  margin-right: 0 !important;*/
/*}*/

/*.dg li {*/
/*  margin: 0 !important;*/
/*}*/

.lil-gui {
  max-height: inherit !important;
}

.lil-gui select {
  color: black;
}

/*.dg.main .close-button.close-bottom {*/
/*  position: relative !important;*/
/*}*/

/*.dg.main.taller-than-window .close-button.close-bottom {*/
/*  position: absolute !important;*/
/*  bottom: 0 !important;*/
/*}*/

/*.dg.main.taller-than-window > ul > li:last-child {*/
/*  margin-bottom: 20px !important;*/
/*}*/

.dg .controller[hidden] {
  display: none;
}

.dg .controller:not([hidden]) {
  display: flex
}

.k3d-target canvas {
  position: relative;
  z-index: 10;
}

.k3d-transfer-function {
  height: 100% !important;
}

.k3d-transfer-function circle {
  cursor: move;
}

.k3d-transfer-function circle.selected {
  /*stroke: red;*/
}

.k3d-color-picker {
  display: none;
}

`, "",{"version":3,"sources":["webpack://./src/k3d.css"],"names":[],"mappings":"AAAA;EACE,2BAA2B;AAC7B;;AAEA,0BAA0B;AAC1B,kBAAkB;AAClB,oCAAoC;AACpC,IAAI;;AAEJ,WAAW;AACX,iCAAiC;AACjC,IAAI;;AAEJ,eAAe;AACf,iCAAiC;AACjC,IAAI;;AAEJ,0BAA0B;AAC1B,6BAA6B;AAC7B,+BAA+B;AAC/B,iCAAiC;AACjC,gCAAgC;AAChC,0BAA0B;AAC1B,IAAI;;AAEJ,UAAU;AACV,gCAAgC;AAChC,IAAI;;AAEJ,WAAW;AACX,0BAA0B;AAC1B,IAAI;;AAEJ;EACE,8BAA8B;AAChC;;AAEA;EACE,YAAY;AACd;;AAEA,wCAAwC;AACxC,mCAAmC;AACnC,IAAI;;AAEJ,2DAA2D;AAC3D,mCAAmC;AACnC,0BAA0B;AAC1B,IAAI;;AAEJ,qDAAqD;AACrD,oCAAoC;AACpC,IAAI;;AAEJ;EACE,aAAa;AACf;;AAEA;EACE;AACF;;AAEA;EACE,kBAAkB;EAClB,WAAW;AACb;;AAEA;EACE,uBAAuB;AACzB;;AAEA;EACE,YAAY;AACd;;AAEA;EACE,eAAe;AACjB;;AAEA;EACE,aAAa;AACf","sourcesContent":[".katex-display {\r\n  margin: 0.25em 0 !important;\r\n}\r\n\r\n/*.dg input, .dg select {*/\r\n/*  color: black;*/\r\n/*  line-height: normal !important;*/\r\n/*}*/\r\n\r\n/*.dg li {*/\r\n/*  list-style: none !important;*/\r\n/*}*/\r\n\r\n/*.dg li > * {*/\r\n/*  margin-bottom: 0 !important;*/\r\n/*}*/\r\n\r\n/*.dg input, .dg select {*/\r\n/*  padding: 3px !important;*/\r\n/*  display: block !important;*/\r\n/*  box-shadow: none !important;*/\r\n/*  font-size: 100% !important;*/\r\n/*  border: 0 !important;*/\r\n/*}*/\r\n\r\n/*.dg.a {*/\r\n/*  margin-right: 0 !important;*/\r\n/*}*/\r\n\r\n/*.dg li {*/\r\n/*  margin: 0 !important;*/\r\n/*}*/\r\n\r\n.lil-gui {\r\n  max-height: inherit !important;\r\n}\r\n\r\n.lil-gui select {\r\n  color: black;\r\n}\r\n\r\n/*.dg.main .close-button.close-bottom {*/\r\n/*  position: relative !important;*/\r\n/*}*/\r\n\r\n/*.dg.main.taller-than-window .close-button.close-bottom {*/\r\n/*  position: absolute !important;*/\r\n/*  bottom: 0 !important;*/\r\n/*}*/\r\n\r\n/*.dg.main.taller-than-window > ul > li:last-child {*/\r\n/*  margin-bottom: 20px !important;*/\r\n/*}*/\r\n\r\n.dg .controller[hidden] {\r\n  display: none;\r\n}\r\n\r\n.dg .controller:not([hidden]) {\r\n  display: flex\r\n}\r\n\r\n.k3d-target canvas {\r\n  position: relative;\r\n  z-index: 10;\r\n}\r\n\r\n.k3d-transfer-function {\r\n  height: 100% !important;\r\n}\r\n\r\n.k3d-transfer-function circle {\r\n  cursor: move;\r\n}\r\n\r\n.k3d-transfer-function circle.selected {\r\n  /*stroke: red;*/\r\n}\r\n\r\n.k3d-color-picker {\r\n  display: none;\r\n}\r\n\r\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
